import { render, staticRenderFns } from "./BookingChecksCell.vue?vue&type=template&id=2f654b79&scoped=true&"
import script from "./BookingChecksCell.vue?vue&type=script&lang=js&"
export * from "./BookingChecksCell.vue?vue&type=script&lang=js&"
import style0 from "./BookingChecksCell.vue?vue&type=style&index=0&id=2f654b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f654b79",
  null
  
)

export default component.exports